import { useOutletContext } from "react-router-dom";
import type { SessionState } from "../types";

interface ShellContext {
  session: SessionState;
}

export function useShellSession(): ShellContext {
  return useOutletContext<ShellContext>();
}
